import React, { useEffect, useLayoutEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import is from 'is_js';
import AppRoutes from 'routes';
import { CloseButton } from 'components/common/Toast';
import { PATH_MAGIC_LINK } from 'routes/route.path';
import { isEmailLinkSignIn } from 'services/firebase.service';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './firebase.config';
import '@stripe/connect-js';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const [isRouterReady, setIsRouterReady] = useState(false);

  useLayoutEffect(() => {
    const basePath =
      process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '/' ? process.env.PUBLIC_URL : '';
    const pathname = window.location.pathname.replace(basePath, '') || '/';

    if (isEmailLinkSignIn(window.location.href) && pathname !== PATH_MAGIC_LINK) {
      window.history.replaceState(
        window.history.state,
        '',
        `${basePath}${PATH_MAGIC_LINK}${window.location.search}${window.location.hash}`
      );
    }

    setIsRouterReady(true);
  }, []);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  if (!isRouterReady) return null;

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppRoutes />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </Router>
  );
};

export default App;
